import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";

function MovieDeatails() {
  const [mDetail, setMDetail] = useState([]);
  var { id } = useParams();
  var { type } = useParams();
  console.log("id", id);

  console.log("typ", type);

  const getMovieDetails = async () => {
    const res = await fetch(
      `https://api.themoviedb.org/3/${type}/${id}?api_key=1c349502ffa6fe67721a2ea4260bed9f&language=en-US`
    );
    const resData = await res.json();
    console.log("re", resData);
    setMDetail(resData);
  };

  useEffect(() => {
    getMovieDetails();
  }, []);

  return (
    <>
      <main style={{ marginTop: "150px" }}>
        <article>
          <section>
            <div className="container">
              <figure className="movie-detail-banner">
                <img
                  src={`https://image.tmdb.org/t/p/w500/${mDetail.poster_path}`}
                  alt="Free guy movie poster"
                />

                <button className="play-btn">
                  <ion-icon name="play-circle-outline"></ion-icon>
                </button>
              </figure>

              <div className="movie-detail-content">
                <p className="detail-subtitle">New Episodes</p>

                <h1 className="h1 detail-title">
                  {type.includes("movie") ? mDetail.title : mDetail.name}
                </h1>

                <div className="meta-wrapper">
                  <div className="badge-wrapper">
                    <div className="badge badge-fill">PG 13</div>

                    <div className="badge badge-outline">HD</div>
                  </div>

                  <div className="ganre-wrapper">
                    <a href="#">Comedy,</a>

                    <a href="#">Action,</a>

                    <a href="#">Adventure,</a>

                    <a href="#">Science Fiction</a>
                  </div>

                  <div className="date-time">
                    <div>
                      <ion-icon name="calendar-outline"></ion-icon>

                      <time datetime="2021">{mDetail.release_date}</time>
                    </div>

                    <div>
                      <ion-icon name="time-outline"></ion-icon>

                      <time datetime="PT115M">{mDetail.runtime}</time>
                    </div>
                  </div>
                </div>
                <p className="storyline">{mDetail.overview}</p>

                <div className="details-actions">
                  <button className="share">
                    <ion-icon name="share-social"></ion-icon>

                    <span>Share</span>
                  </button>

                  <div className="title-wrapper">
                    <p className="title">Prime Video</p>

                    <p className="text">Streaming Channels</p>
                  </div>

                  <button className="btn btn-primary">
                    <ion-icon name="play"></ion-icon>

                    <span>Watch Now</span>
                  </button>
                </div>

                <a
                  href={mDetail.backdrop_path}
                  download
                  className="download-btn"
                >
                  <span>Download</span>

                  <ion-icon name="download-outline"></ion-icon>
                </a>
              </div>
            </div>
          </section>
        </article>
      </main>
    </>
  );
}

export default MovieDeatails;
